import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';

import background from '../../assets/images/student/StudentViewFinalSmall.jpg';
import logo from '../../assets/images/logo.png';
import Footer from '../../components/UI/Footer';
import PrivateRoute from 'routing/PrivateRoute';

import { ToastContainer } from 'react-toastify';
import '../../containers/Student/student.scss';
import { connect } from 'react-redux';
import { isEmpty } from '@lsgo/lsgo-common';
import ToastifyNotification from 'components/UI/Notifications/ToastifyNotification';

const EmptyLayout = ({
    component: Component,
    noBox,
    auth,
    serverNotifications,
    sentralUnsafeRoute,
    history,
    ...rest
}) => {
    const [toastType, setToastType] = useState(null);
    const path = rest.location.pathname ? rest.location.pathname : '';

    useEffect(() => {
        if (serverNotifications && !isEmpty(serverNotifications.message)) {
            serverNotifications.type === 'warning'
                ? setToastType('server-notification warning-notification')
                : setToastType('server-notification success-notification');
        }
    }, [serverNotifications]);

    return (
        <>
            <div
                className='student-main-background container-fluid studentv2'
                style={{
                    backgroundImage: 'url(' + background + ')',
                }}
            >
                <div className='row'>
                    <div className='col-12 top-bar'>
                        <div className='row'>
                            <div className='col-3 main-logo'>
                                <Link to='/teacher'>
                                    <img alt='LSGO ' id='lsgo-logo' src={logo} />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='col-12 main-studnet-content'></div>
                <div id='canvas-wrapper2'>
                    {noBox ? (
                        <PrivateRoute
                            isAuthenticated={auth.isAuthenticated}
                            routeType={
                                path.includes('rollcall') || path.includes('quick-weather-report')
                                    ? 'private'
                                    : sentralUnsafeRoute
                                    ? 'sentral'
                                    : 'guest'
                            }
                            {...rest}
                            render={(props) => <Component {...props} />}
                        />
                    ) : (
                        <div className={`student-box2`}>
                            <PrivateRoute
                                isAuthenticated={auth.isAuthenticated}
                                routeType={
                                    path.includes('rollcall') || path.includes('quick-weather-report')
                                        ? 'private'
                                        : sentralUnsafeRoute || path.includes('sentral')
                                        ? 'sentral'
                                        : 'guest'
                                }
                                {...rest}
                                render={(props) => <Component {...props} />}
                            />
                        </div>
                    )}
                </div>
                {/* Button Specifically for quick Emotion Check-in */}
                <div className='student-action-buttons text-center'>
                    <div className='actionButtons'>
                        {rest.path === '/teacher/quick-weather-report/:classId' && (
                            <div
                                className='btn btn-lsgo btn-rounded waves-light mt-2 mb-4'
                                onClick={() => {
                                    history.action === 'PUSH' ? history.goBack() : history.push('/');
                                }}
                            >
                                Back to Dashboard
                            </div>
                        )}

                        {rest.path === '/teacher/rollcall/:classId' && (
                            <div
                                className='btn btn-lsgo btn-rounded waves-light mt-2 mb-4'
                                onClick={() => {
                                    history.action === 'PUSH' ? history.goBack() : history.push('/');
                                }}
                            >
                                Back to Dashboard
                            </div>
                        )}
                    </div>
                </div>

                <ToastContainer toastClassName={toastType} autoClose={false} />
                <div>
                    <ToastifyNotification />
                </div>
                <Footer />
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    serverNotifications: state.ui.serverNotifications,
});

export default withRouter(connect(mapStateToProps)(EmptyLayout));
